import { topicBoard } from '@/mocks/home';

export default function TopicBoard() {
  return (
    <section id="topics" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-8 md:py-10">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-layout-grid-line" />
            </span>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">题材速览 · 今日收录分布</h2>
              <p className="mt-1 text-sm text-foreground-600">按题材看今天哪一类的信息量最大，点开就是对应的时间线。</p>
            </div>
          </div>
          <a
            href="#feed"
            className="flex h-8 items-center gap-1 self-start whitespace-nowrap font-label text-xs font-medium text-primary-700 transition-colors hover:text-primary-600 md:self-auto"
          >
            回到快讯流筛选
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>

        <div className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-4">
          {topicBoard.map((topic) => (
            <article
              key={topic.name}
              className="group flex flex-col justify-between rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-secondary-300"
            >
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950">{topic.name}</h3>
                <span className="font-heading text-lg font-bold tabular-nums text-secondary-700">{topic.count}</span>
              </div>
              <p className="mt-3 font-label text-[11px] leading-relaxed text-foreground-500">{topic.hot}</p>
              <span className="mt-3 h-1 w-full overflow-hidden rounded-full bg-background-200">
                <span
                  className="block h-full rounded-full bg-secondary-400 transition-all duration-500 group-hover:bg-secondary-500"
                  style={{ width: `${Math.min(100, (topic.count / 38) * 100)}%` }}
                />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}